<div class="col-12" style="text-align: right!important;">
    <p-button pRipple type="button" (click)="showDialog()" icon="fas fa-note-sticky" styleClass="p-button-sm p-button-info" pTooltip="Generare nota de livrare" tooltipPosition="left"></p-button>
</div>
